import React, { useState } from "react";

import { SlidersHorizontal } from "lucide-react";
import { Button } from "../components/ui/Button";
import ProductDetailPopup from "./ProductDetailPopup";
import RequestQuotationModal from "./RequestQuotationModal";

const products = [
  // Dehydrated Products (3 items)
  {
        id: "P001",
        image: require("../assets/dRed.jpeg"), // Suggested: crispy red & white fried onions in a bowl
        name: "Dehydrated Fried Onions Red",
        category: "Dehydrated",
        description: "Crunchy, flavor-packed fried onions made from red onion varieties, ideal for garnishing and seasoning.",
        hexCode: "25585DF53",
      },
      
      {
        id: "P002",
        image: require("../assets/white.jpeg"), // Suggested: coated onion rings close-up
        name: "Dehydrated Fried Coated Onions White",
        category: "Dehydrated",
        description: "Deep-fried coated white onion slices with a crisp outer layer, perfect for snacks or toppings.",
        hexCode: "25585DF53",
      },
      {
        id: "P003",
        image: require("../assets/red_o_powder.png"), // Suggested: red onion powder in spoon or bowl
        name: "Red Onion Powder",
        category: "Dehydrated",
        description: "Finely ground powder made from dried red onions, rich in flavor and aroma for everyday cooking.",
        hexCode: "25585DF53",
      },
      {
        id: "P004",
        image: require("../assets/white_onion_powder.png"), // Suggested: white powder in spice jar
        name: "White Onion Powder",
        category: "Dehydrated",
        description: "Smooth, light-colored powder from dried white onions, great for soups, sauces, and seasoning.",
        hexCode: "25585DF53",
      },
      {
        id: "P006",
        image: require("../assets/flakes.jpeg"), // Suggested: colorful red and white onion flakes on a wooden plate
        name: "Red and White Onion Flakes",
        category: "Dehydrated",
        description: "Mixed flakes of red and white dehydrated onions, perfect for soups, pizzas, and savory dishes.",
        hexCode: "25585DF53",
      },
       {
        id: "P007",
        image: require("../assets/red.jpeg"), // Suggested: coated onion rings close-up
        name: "Dehydrated Fried Coated Onions Red",
        category: "Dehydrated",
        description: "Deep-fried coated white onion slices with a crisp outer layer, perfect for snacks or toppings.",
        hexCode: "25585DF53",
      },
           {
        id: "P008",
        image: require("../assets/dwhite.jpeg"), // Suggested: crispy red & white fried onions in a bowl
        name: "Dehydrated Fried Onions White",
        category: "Dehydrated",
        description: "Crunchy, flavor-packed fried onions made from  white onion varieties, ideal for garnishing and seasoning.",
        hexCode: "25585DF53",
      },
      {
        id: "P302",
        image: require("../assets/badgya_chilly.png"), // Suggested: Byadgi chillies next to their powder
        name: "Byadgi Mirchi Powder",
        category: "Chilly",
        description: "Mildly spicy, deep red powder made from Byadgi chillies, popular in Indian cuisine for its color and aroma.",
        hexCode: "25585DF55",
      },
      {
        id: "P308",
        image: require("../assets/Guntur.jpg"),
        name: "Guntur Chilli",
        category: "Chilly Powder",
        description:
          "Famous for its intense spiciness, Guntur chillies are a staple in South Indian dishes and exports.",
        hexCode: "25585DF55",
      },
  // {
  //   id: "P007",
  //   image: require("../assets/red_chilly_powder.png"),
  //   name: "Teja Mirchi",
  //   category: "Chilly Powder",
  //   description:
  //     "Known for its high pungency and deep red color, Teja chillies are ideal for hot and spicy Indian dishes.",
  //   hexCode: "25585DF55",
  // },
  // {
  //   id: "P008",
  //   image: require("../assets/red_chilly_powder.png"),
  //   name: "Byadgi Mirchi",
  //   category: "Chilly Powder",
  //   description:
  //     "Whole Byadgi chillies with rich red hue and mild heat, perfect for vibrant and aromatic masalas.",
  //   hexCode: "25585DF55",
  // },
  // {
  //   id: "P009",
  //   image: require("../assets/red_chilly_powder.png"),
  //   name: "Kashmiri Mirchi",
  //   category: "Chilly Powder",
  //   description:
  //     "Low on heat but rich in color, Kashmiri mirchi is widely used to impart a deep red color to gravies.",
  //   hexCode: "25585DF55",
  // },
  // {
  //   id: "P010",
  //   image: require("../assets/red_chilly_powder.png"),
  //   name: "Guntur Chilli",
  //   category: "Chilly Powder",
  //   description:
  //     "Famous for its intense spiciness, Guntur chillies are a staple in South Indian dishes and exports.",
  //   hexCode: "25585DF55",
  // },

  // Turmeric Powder (2 items, 1 real + 1 placeholder)
  {
    id: "P011",
    image: require("../assets/organic_turmeric_powder.png"),
    name: "Organic Turmeric Powder",
    category: "Turmeric Powder",
    description:
      "High-quality turmeric powder rich in curcumin, known for its anti-inflammatory and antioxidant properties.",
    hexCode: "25585DF54",
  }
];


const FilterModal = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-[#FBF1EB] p-3 rounded-md w-full sm:w-3/4 md:w-1/3 lg:w-1/4 shadow-lg">
        <h2 className="text-lg font-bold mb-4">Category</h2>
        <ul className="space-y-2">
          {["Dehydrated Products", "Turmeric Powder", "Chilly Powder"].map((category) => (
            <li
              key={category}
              className="py-2 cursor-pointer border-b border-gray-300 text-[#753611] hover:bg-[#814726] hover:text-white px-5 transition duration-200"
              onClick={() => {
                onSelect(category);
                onClose();
              }}
            >
              {category}
            </li>
          ))}
        </ul>

        <div className="flex justify-between mt-4">
          <Button
            variant="outline"
            className="w-40"
            onClick={() => {
              onSelect(null);
              onClose();
            }}
          >
            Clear Filter
          </Button>
          <Button className="w-40" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default function Collection() {
  const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
  const [isProductDetailOpen, setIsProductDetailOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const openQuotationModal = (product) => {
    setSelectedProduct(product);
    setIsQuotationModalOpen(true);
  };

  const closeQuotationModal = () => setIsQuotationModalOpen(false);

  const openProductDetail = (product) => {
    setSelectedProduct(product);
    setIsProductDetailOpen(true);
  };

  const closeProductDetail = () => setIsProductDetailOpen(false);

  const filteredProducts = selectedFilter
    ? products.filter((product) => product.category === selectedFilter)
    : products;

  return (
    <div className="min-h-screen bg-[#FBF1EB]">


      {/* Collection Grid */}
      <section className="w-full py-12 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mb-5 drop-shadow-sm">FEATURED PRODUCTS</h1>

          <div className="flex justify-between items-center mb-8">
            <div></div>
            <button
              className="text-[#73340E]"
              onClick={() => setIsFilterModalOpen(true)}
            >
              <SlidersHorizontal size={24} />
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
              <div key={product.id} className="flex flex-col items-center">
                <div
                  className="w-full aspect-square relative mb-2 overflow-hidden cursor-pointer"
                  onClick={() => openProductDetail(product)}
                >
                <img
    src={product.image}
    alt={product.name}
    className="object-contain w-full h-full rounded-md hover:scale-105 transition-transform duration-300"
  />
                </div>
                <h3 className="text-lg font-medium text-[#34302B] mb-2 text-center">
                  {product.name}
                </h3>
                <Button
                  className="bg-[#73340E] hover:bg-[#C09670] text-white text-sm"
                  onClick={() => openQuotationModal(product)}
                >
                  Request Quotation
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modals */}
      <RequestQuotationModal
        isOpen={isQuotationModalOpen}
        onClose={closeQuotationModal}
        productName={selectedProduct?.name || ""}
        productId={selectedProduct?.id || ""}
      />

      {selectedProduct && (
        <ProductDetailPopup
          isOpen={isProductDetailOpen}
          onClose={closeProductDetail}
          onRequestQuotation={() => {
            closeProductDetail();
            openQuotationModal(selectedProduct);
          }}
          product={selectedProduct}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onSelect={setSelectedFilter}
      />

    </div>
  );
}
